export class CancelAbortingQuery extends Error {}
